import React, { Component } from 'react';
import countapi from 'countapi-js';

class VisitBlog extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  componentDidMount() {
    countapi.visits('blog').then((result) => {
      console.log(result)
      this.setState({ visiteBlog: result.value });
    });
  }

  render() {

    return (
      <span style={{fontSize: '18px', marginBottom: '-20.5px'}} title="Numero delle visite sulla pagina 'Blog'">(👁 {this.state.visiteBlog})</span>
    );

  }
}

export default VisitBlog;